/**
 * Stacking order for everything voice-related.
 *
 * The app's drawers are `react-modern-drawer`, which renders its overlay at
 * z-index 100 and its own panel at 101 — well above the `z-50` most floating UI
 * uses. Anything voice-related opened from inside a drawer (the inbox Details
 * panel is the one that matters) therefore lands *under* that overlay: dimmed by
 * its backdrop, and every click on it hits the overlay instead, which closes the
 * drawer and unmounts whatever was inside it.
 */

/** Pre-dial modal — must clear the drawer panel (101). */
export const PRE_DIAL_MODAL_Z_INDEX = 102;

/**
 * The live-call card, pill and disposition dialog. Deliberately above the
 * pre-dial modal as well: hanging up must never be covered by another layer.
 * (The mic/reconnect toasts go through the global ToastContainer, which
 * stacks above everything on its own.)
 */
export const SOFTPHONE_OVERLAY_Z_CLASS = "z-[110]";

/**
 * The in-call Create-lead modal (CRM-905) — opened from the live-call card, so
 * it must clear the softphone overlay itself.
 */
export const IN_CALL_LEAD_MODAL_Z_INDEX = 120;
